export const adminRoles = [   
   { label: 'Country Admin', value: 'admin' },
   { label: 'Admin 1 - Access Partner without Rates', value: 'admin1' },
   { label: 'Admin 2 - Access Partner with Rates', value: 'admin2' },
   { label: 'Web',value: 'webAdmin'},
   { label: 'Accountant', value: 'accountant' },
   { label: 'Job Applicant', value: 'jobApplicant' }

 ]

 export const daysOptions = [
   { label: 'Monday', value: 'Monday' },
   { label: 'Tuesday', value: 'Tuesday' },
   { label: 'Wednesday', value: 'Wednesday' },
   { label: 'Thursday', value: 'Thursday' },
   { label: 'Friday', value: 'Friday' },
   { label: 'Saturday', value: 'Saturday' },
   { label: 'Sunday', value: 'Sunday' }
 ]

//  export const jobApplicationStatus = [   
//   { label: 'submitted', value: 'submitted' },
//   { label: 'application viewed', value: 'application viewed' },
//   { label: 'shortlisted', value: 'shortlisted' },
//   { label: 'rejected',value: 'rejected'}

// ]